export const getPercentage = (value) => {
	const result = value * 100;
	if (!result) {
		return '';
	}
	return `(${result.toFixed(2)}%)`;
};
